import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import agora from './agora'
import app from './app'
import appConfig from './app-config'
import auth from './auth'
import payment from './payment'
import search from './search'
import socket from './socket'
import verticalMenu from './vertical-menu'
// eslint-disable-next-line import/no-cycle
import voiceRoom from './voice-room'
import videoRoom from './video-room'
import users from './users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    agora,
    app,
    appConfig,
    auth,
    payment,
    search,
    socket,
    verticalMenu,
    voiceRoom,
    videoRoom,
    users,
  },
  strict: process.env.DEV,
})
